/*
 * @Descripttion: 
 * @Author: pangting
 * @Date: 2020-04-26 10:28:57
 */
import { BaseApi } from "@newview/infrastructure";

export abstract class SysConfigBaseApi extends BaseApi {
    public get ProxyName(): any {
        return 'SysApi'
    }
}